import { QueryClientProvider, QueryClient } from "react-query";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { UserProvider, useUser } from "./Context/UserContext";
import React, { useEffect, useRef } from "react";
import ResourceNotFound from "./CapsitechAccountsComponents/Common/ResourceNotFound";
import ThemeContextProvider from "./CapsitechAccountsComponents/Context/ThemeContext";
import AdminContextState from "./Context/AdminContextState";
import Login from "./Common/Login/Login";
import MainClientTable from "./CapsitechAccountsComponents/Common/MainClientTable";
import ForgotPassword from "./Common/Login/ForgotPassword";
import AccountsMainLayout from "./CapsitechAccountsComponents/Common/MainLayout";
import Clients from "./CapsitechAccountsComponents/Pages/Clients/Clients";
import UsersDetailsTabs from "./CapsitechAccountsComponents/Pages/Users/Others/UsersDetailsTabs";
import Customer from "./CapsitechAccountsComponents/Pages/Customer/Customer";
import Product from "./CapsitechAccountsComponents/Pages/Products/Product";
import VendorRegistration from "./CapsitechAccountsComponents/Pages/Vendors/VendorRegistration/VendorRegistration";
import VendorLogIn from "./CapsitechAccountsComponents/Pages/Vendors/VendorLogIn";
import VendorWebPage from "./CapsitechAccountsComponents/Pages/Vendors/VendorWebPage/VendorWebPage";
import Profiletabs from "./CapsitechAccountsComponents/Common/Profiletabs";
import UserTabs from "./CapsitechAccountsComponents/Pages/Users/Users/UserTabs";
import { RoleProvider } from "./Context/RoleContext";
import MainSuperAdminTable from "./CapsitechAccountsComponents/Common/MainSuperAdminTable";
import GstTable from "./CapsitechAccountsComponents/Pages/GST/GstTable";
import { Utils } from "./Utilities/Utils";
import { IThemeData } from "./CapsitechAccountsComponents/Common/ThemeSetting";
import { HotkeyProvider } from "./CapsitechAccountsComponents/Context/HotKeyContext";
import BillingHomeWebsite from "./Common/Login/BillingWebsite/BillingHomeWebsite";
import InventoryHomeWebsite from "./Common/Login/InventoryWebsite/InventoryHomeWebsite";
import InventoryClient from "./CapsitechAccountsComponents/Pages/Clients/InventoryClient";
import InventorySignUp from "./Common/Login/InventoryWebsite/InventorySignUp";
import BillingSignUp from "./Common/Login/BillingWebsite/BillingSignUp";
import VendorCreatePassword from "./CapsitechAccountsComponents/Pages/Vendors/VendorRegistration/VendorCreatePassword";
import VendorPageRoute from "./CapsitechAccountsComponents/Common/VendorPageRoute";

export const queryClient = new QueryClient();

const App = () => {
  const { getUser } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [isloggedIn, setIsLoggedIn] = React.useState<boolean>(
    false || JSON.parse(sessionStorage.getItem("state") + "")
  );
  const { isAuthenticated } = useUser();
  const qryFields = new URLSearchParams(location.search);
  const paramToken = qryFields.get("token");
  let loginUser = { ...getUser() };

  const previousPath: any = useRef(null);
  useEffect(() => {
    const token = localStorage.getItem(`${window.location.hostname}|AO.Token`);

    const splitPath = location.pathname.split("/");

    // Check if the user is logged in
    if (token) {
      // If the user is logged in and the route is /login, navigate to /accounts
      if (splitPath[1] === "login" || splitPath[1] === "") {
        navigate("/books");
      }
    } else {
      // If the user is logged out, and the route is not /forgotpassword, navigate to /login
      if (
        splitPath[1] !== "login" &&
        splitPath[1] !== "forgotpassword" &&
        splitPath[1] !== "vendor" &&
        splitPath[1] !== "vendor/login"
      ) {
        navigate("/login");
      }
    }
    // If the user is logged out and the route is /forgotpassword, navigate to /forgotpassword
    // if (!isloggedIn && splitPath[1] === "forgotpassword") {
    //   debugger;
    //   navigate("/forgotpassword");
    // }
    // Vendor path
    //if (!token && splitPath[1] === "vendor") {
    //  navigate(`${location.pathname}`);
    //}
    if (!paramToken && splitPath[2] === "createpassword") {
      navigate(`vendor`);
    }

    // Update previousPath with the current path
    previousPath.current = location.pathname;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  console.log("loginUser?.customerId", loginUser?.customerId);

  // Apply or remove zebra striping based on the setting
  React.useEffect(() => {
    const zebraStyleId = "zebra-style";
    let zebraStyleTag = document.getElementById(zebraStyleId);
    const getThemeLocalData: IThemeData = Utils.getLocal("ci-config");

    if (getThemeLocalData?.zebraStriped) {
      //  create or update zebra style
      if (!zebraStyleTag) {
        zebraStyleTag = document.createElement("style");
        zebraStyleTag.id = zebraStyleId;
        document.head.appendChild(zebraStyleTag);
      }
      zebraStyleTag.innerHTML = `
        /* Apply zebra stripes to all Ant Design tables */
        .ant-table-tbody > tr:nth-child(even) > td {
          background-color: #f7f7f7 !important; 
        }
      `;
    } else {
      //  remove zebra style when turned off
      if (zebraStyleTag) {
        zebraStyleTag.remove();
      }
    }
  }, []);

  return (
    <AdminContextState>
      <UserProvider>
        <RoleProvider>
          <ThemeContextProvider>
            <QueryClientProvider client={queryClient}>
              {/* <React.Suspense> */}
              <Routes>
                <Route
                  element={
                    <Login
                      setIsLoggedIn={setIsLoggedIn}
                      isloggedIn={isloggedIn}
                    />
                  }
                  path="/login"
                />
                <Route element={<BillingHomeWebsite />} path="/billinghome" />
                <Route
                  element={<InventoryHomeWebsite />}
                  path="/inventoryhome"
                />
                <Route element={<InventorySignUp />} path="/inventory/signup" />
                <Route element={<BillingSignUp />} path="/books/signup" />

                {/* Vendor Routes */}

                <Route element={<VendorWebPage />} path="/vendor" />
                <Route element={<VendorLogIn />} path="/vendor/login" />
                <Route element={<VendorPageRoute />} path="/vendor/*" />
                <Route
                  element={<VendorCreatePassword />}
                  path="/vendor/createpassword"
                />
                {loginUser?.customerId ? (
                  <>
                    <Route
                      element={
                        <MainClientTable
                          setIsLoggedIn={setIsLoggedIn}
                          isloggedIn={isloggedIn}
                          element={
                            <HotkeyProvider>
                              <Clients />
                            </HotkeyProvider>
                          }
                        />
                      }
                      path="/books"
                    />
                    <Route
                      element={
                        <MainClientTable
                          setIsLoggedIn={setIsLoggedIn}
                          isloggedIn={isloggedIn}
                          element={
                            <HotkeyProvider>
                              <InventoryClient />
                            </HotkeyProvider>
                          }
                        />
                      }
                      path="/inventory"
                    />
                  </>
                ) : (
                  <Route
                    element={
                      <MainSuperAdminTable
                        element={<Customer />}
                        breadcrumprops={[
                          {
                            item: "Customer",
                          },
                        ]}
                      />
                    }
                    path="/books/customer"
                  />
                )}
                <Route
                  element={<ForgotPassword />}
                  // path="/forgotpassword/:userId/:code/*"
                  path="/forgotpassword"
                />
                {/* <Route path='/reset-password/:userId/:code' element={<ResetPassword />} /> */}
                {/* <Route
                  element={
                    <MainClientTable
                      element={<GeneralSettings />}
                      breadcrumprops={[
                        {
                          item: "GeneralSettings",
                        },
                      ]}
                    />
                  }
                  path="/accounts/generalsettings"
                /> */}
                <Route
                  element={
                    <MainSuperAdminTable
                      element={<GstTable />}
                      breadcrumprops={[
                        {
                          item: "Gst",
                        },
                      ]}
                    />
                  }
                  path="/books/gst"
                />
                <Route
                  element={
                    <MainClientTable
                      element={
                        <HotkeyProvider>
                          <UserTabs />
                        </HotkeyProvider>
                      }
                      breadcrumprops={[
                        {
                          item: "Users",
                        },
                      ]}
                    />
                  }
                  path="/books/users"
                />
                {/* <Route
                  element={
                    <MainSuperAdminTable
                      element={<Customer />}
                      breadcrumprops={[
                        {
                          item: "Customer",
                        },
                      ]}
                    />
                  }
                  path="/books/customer"
                /> */}
                <Route
                  element={
                    <MainSuperAdminTable
                      element={<Product />}
                      breadcrumprops={[
                        {
                          item: "Product",
                        },
                      ]}
                    />
                  }
                  path="/books/product"
                />
                <Route
                  element={
                    <MainClientTable
                      element={<UsersDetailsTabs />}
                      breadcrumprops={[
                        {
                          item: "Users",
                        },
                      ]}
                    />
                  }
                  path="/books/users/userDetails"
                />
                {/* <Route
                element={<AsyncAccountsMainLayout />}
                path="/accounts/clients/:clientid/*"
              /> */}
                <Route
                  element={
                    <HotkeyProvider>
                      <AccountsMainLayout />
                    </HotkeyProvider>
                  }
                  path="/books/clients/*"
                />
                <Route
                  element={
                    <HotkeyProvider>
                      <AccountsMainLayout />
                    </HotkeyProvider>
                  }
                  path="/inventory/clients/*"
                />
                {/* Vendor Routes */}
                <Route element={<VendorWebPage />} path="/vendor/*" />
                <Route
                  element={
                    <VendorWebPage
                    // setIsLoggedIn={setIsLoggedIn}
                    // isloggedIn={isloggedIn}
                    />
                  }
                  path="/vendor/clients/:vendorClientId"
                />
                <Route
                  element={
                    <VendorLogIn
                    // setIsLoggedIn={setIsLoggedIn}
                    // isloggedIn={isloggedIn}
                    />
                  }
                  path="/vendor/clients/:vendorClientId/logIn"
                />
                <Route
                  element={
                    <VendorRegistration

                    // setIsLoggedIn={setIsLoggedIn}
                    // isloggedIn={isloggedIn}
                    />
                  }
                  path="/vendor/clients/:vendorClientId/registration"
                />
                {/* ///TODO: Need to Handle sidenavigation and other routes of Vendor */}
                {/* <Route
                  element={
                    <SideNavigation
                    // setIsLoggedIn={setIsLoggedIn}
                    // isloggedIn={isloggedIn}
                    />
                  }
                  path="/vendor/*"
                /> */}
                {/* <Route
                element={
                  <MainClientTable
                    element={<Customer />}
                    breadcrumprops={[
                      {
                        item: "Customer",
                      },
                    ]}
                  />
                }
                path="/accounts"
              /> */}
                {/* <Route
                element={
                  <SideNavigation
                    element={<Vendo />}
                    breadcrumprops={[
                      {
                        item: "Customer",
                      },
                    ]}
                  />
                }
                path="/vendor/*"
              /> */}
                {/* <Route element={<VendorPageRoute />} path="/vendor/*" /> */}
                {/* <Route element={<VendorPageRoute />} path="vendor/dashboard/" /> */}
                <Route
                  element={
                    <MainClientTable
                      element={<Profiletabs />}
                      breadcrumprops={[
                        {
                          item: "Profile",
                        },
                      ]}
                    />
                  }
                  path="/books/setting"
                />
                {/* <Route
                  element={
                    <MainSuperAdminTable
                      element={<TscList Role="SUPERADMIN" />}
                      breadcrumprops={[
                        {
                          item: "Tcs",
                        },
                      ]}
                    />
                  }
                  path="/books/Tcs"
                />
                <Route
                  element={
                    <MainSuperAdminTable
                      element={<TdsList Role="SUPERADMIN" />}
                      breadcrumprops={[
                        {
                          item: "Tds",
                        },
                      ]}
                    />
                  }
                  path="/books/Tds"
                /> */}
                {isAuthenticated() && (
                  <Route
                    element={<ResourceNotFound pageHeight="100vh" />}
                    path="*"
                  />
                )}
              </Routes>
              {/* </React.Suspense> */}
            </QueryClientProvider>
          </ThemeContextProvider>
        </RoleProvider>
      </UserProvider>
    </AdminContextState>
  );
};

export default App;
